import Select from './Select';
import Option from './Option';
import { SelectPropTypes } from './PropTypes';
import OptGroup from './OptGroup';

Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;
